import types from "../types/types";
import { Jurado } from "../../models/JuradosModel/jurados.model";

export const idJurados = (idJurado: number) => ({
  type: types.id_jurado,
  payload: {
    idJurado,
  },
});

export const juradoEditar = (editarJurado: boolean) => ({
  type: types.editar_jurado, 
  payload: {
    editarJurado,
  },
});

export const juradoPostulado = (juradoPostulado: string) => ({
  type: types.jurado_postulado,
  payload: {
    juradoPostulado
  }
})

export const invitacionJurados = (invitacionJurado: boolean) => ({
  type: types.invitacion_jurado,
  payload: {
    invitacionJurado,
  },
  
})

export const setModalJuryPostulate = (setModalJuryPostulate: boolean) => ({
  type: types.setModalJuryPostulate,
  payload: {
    setModalJuryPostulate
  }
})

export const guardarJuradosCriterios = (jurados: Array<Jurado>) => ({
  type: types.jurados_criterios,
  payload: {
    jurados
  }
})

export const guardarEducacionJurado = ( educacion : number ) => ({
  type: types.jurado_educacion,
  payload: {
    educacion
  }
})

export const juradoAtras = ( jurado_atras: boolean ) => ({
  type: types.jurados_atras,
  payload: {
    jurado_atras
  }
})

export const menuJuradoAction = (menuJurado: boolean) => ({
  type: types.menu_jurado,
  payload: {
    menuJurado,
  }
})
export const secuencia = (sec: any) => ({
  type: types.sec,
  payload: {
    sec,
  }
})


export const asignarProyectos = (proyectosAsignados: any) => ({
  type: types.proyectosAsignados,
  payload: {
    proyectosAsignados,
  }
})